import React, { useEffect } from 'react'
import { useAuth } from 'context/auth'
import AuthRoutes from './auth-routes'
import AdminRoutes from './admin-routes'
import NoLocationRoutes from './nolocation-routes'
import InvalidAccessRoutes from './unauthorize-routes'
import SubscriptionExpiredRoutes from './subscription-expired-routes'
import ChangePassRequiredRoutes from './change-pass-req-routes'
import OnboardingRoutes from './onboarding-routes'
import PendingRoutes from './pending-routes'
import { ROLES } from 'enums/user'
import { useLocationInfo } from 'context/location'
import AppRoutes from './app-routes'

const needsOnboarding = (location) =>
  location?._id && !location?.basic_info?.city

const Routes = () => {
  const { currentUser, saveAuth } = useAuth()
  const { location, isAccessable } = useLocationInfo()
  const currentRoutes = AppRoutes
  const routes = []

  // PUBLIC
  if (!currentUser) {
    currentRoutes[0].children = routes.concat(AuthRoutes)
    return currentRoutes
  }

  const validUserRole = [ROLES.AGENCY, ROLES.ADMIN]

  // PREMISSION DENIED
  if (
    currentUser &&
    !currentUser.roles.some((role) => validUserRole.includes(role))
  ) {
    currentRoutes[0].children = routes.concat(InvalidAccessRoutes)
    return currentRoutes
  }

  // NO AGENCY FOUND
  if (currentUser && !location?._id) {
    currentRoutes[0].children = routes.concat(NoLocationRoutes)
    return currentRoutes
  }

  // CHANGE PASSWORD REQUIRED
  if (currentUser && currentUser.change_pass_required) {
    currentRoutes[0].children = routes.concat(ChangePassRequiredRoutes)
    return currentRoutes
  }

  // ONBOARDING — new users who haven't filled in basic business info
  // TODO: re-enable once signup flow sets basic_info correctly on all paths
  if (currentUser && needsOnboarding(location)) {
    currentRoutes[0].children = routes.concat(OnboardingRoutes)
    return currentRoutes
  }

  // PENDING APPROVAL (T78 / T100) — merchant has finished onboarding but has not
  // been activated by a superadmin yet. Runs AFTER onboarding so a new merchant
  // fills in their business details first, then waits for approval. Approval is
  // per-Business (T100): prefer the owning Business's state when populated, and
  // fall back to the branch's own active flag (which mirrors the Business).
  // Strict === false so legacy merchants (active true/undefined) are never gated.
  const business = location?.business_id
  const isPending =
    business && typeof business === 'object'
      ? business.active === false
      : location.active === false
  if (currentUser && location?._id && isPending) {
    currentRoutes[0].children = routes.concat(PendingRoutes)
    return currentRoutes
  }

  // // Subscription Expired Layout
  // if (location?.stripe && location?.stripe?.status !== 'active') {
  //   currentRoutes[0].children = routes.concat(SubscriptionExpiredRoutes)
  //   return currentRoutes
  // }
  if (currentUser) {
    // ADMIN
    currentRoutes[0].children = routes.concat(AdminRoutes(isAccessable))
    return currentRoutes
  }

  return currentRoutes
}

export default Routes
